import { REGULATION } from '../constants/regulation';
import RegulationHelper from './regulationHelper';

class EnvHelper {
  static instance = null;

  constructor() {
    if (EnvHelper.instance) {
      return EnvHelper.instance;
    }
    EnvHelper.instance = this;
  }

  static getInstance() {
    if (!EnvHelper.instance) {
      EnvHelper.instance = new EnvHelper();
    }
    return EnvHelper.instance;
  }

  isFSC(forceFSC = false) {
    return RegulationHelper.getInstance().getRegulationId() === REGULATION.FSC || forceFSC;
  }

  getApiUrl(forceFSC = false) {
    if (this.isFSC(forceFSC)) {
      return process.env.REACT_APP_API_URL_FSC;
    }
    return process.env.REACT_APP_API_URL;
  }

  getGrpcUrl(server = '') {
    const grpcUrls = {
      live: process.env.REACT_APP_GRPC_LIVE,
      live1: process.env.REACT_APP_GRPC_LIVE_1,
      live2: process.env.REACT_APP_GRPC_LIVE_2,
      live3: process.env.REACT_APP_GRPC_LIVE_3,
      live4: process.env.REACT_APP_GRPC_LIVE_4,
      live5: process.env.REACT_APP_GRPC_LIVE_5,
      demo: process.env.REACT_APP_GRPC_DEMO
    };
  
    if (this.isFSC()) {
      const grpcUrlsFSC = {
        live: process.env.REACT_APP_GRPC_FSC_LIVE,
        demo: process.env.REACT_APP_GRPC_FSC_DEMO
      };
      return grpcUrlsFSC[server] ?? grpcUrlsFSC.live;
    }

    return grpcUrls[server];
  }

  isDevelopment() {
    return process.env.NODE_ENV === 'development';
  }

  isProduction() {
    return process.env.NODE_ENV === 'production';
  }
}

export default EnvHelper;
